import { newsItems } from '@/mocks/homeData';

export default function NewsInsights() {
  return (
    <section id="news" className="py-20 md:py-28 bg-white">
      <div className="section-container">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-14">
          <div className="animate-on-scroll">
            <div className="inline-flex items-center px-3 py-1.5 rounded-full bg-primary-50 text-primary-600 text-xs font-medium mb-5">
              News & Insights
            </div>
            <h2 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-800 mb-3">
              Latest From<br />Beaumonde Tex Ltd

            </h2>
          </div>
          <div className="animate-on-scroll animate-on-scroll-delay-1 mt-4 md:mt-0">
            <a
              href="#"
              className="inline-flex items-center gap-2 text-sm font-heading font-semibold text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
            >
              View All News <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {newsItems.map((item, i) => (
            <article
              key={item.id}
              className={`group bg-white rounded-lg border border-[#E6EAF0] overflow-hidden hover:border-primary-200 hover:shadow-sm transition-all duration-300 cursor-pointer animate-on-scroll animate-on-scroll-delay-${i + 1}`}
            >
              <div className="relative overflow-hidden aspect-[3/2]">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex px-2.5 py-1 bg-white/90 backdrop-blur-sm rounded text-[10px] font-medium text-primary-600">
                    {item.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <time className="text-[11px] text-foreground-400 mb-2 block">
                  {new Date(item.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                </time>
                <h3 className="text-sm font-heading font-semibold text-foreground-800 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.excerpt}
                </p>
                <a
                  href="https://textiletoday.com.bd/bgmea-nominates-industry-leader-to-support-small-cottage-industry-growth"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-4 flex items-center text-primary-500 text-xs font-medium font-heading hover:text-primary-600 transition-colors"
                >
                  Read More <i className="ri-arrow-right-line ml-1 text-[10px]"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}